export const userSelector = (state) => state.users.currentUser;
export const projectsSelector = (state) => state.projects.items;
export const projectsArchivedSelector = (state) => state.projects.itemsArchived;
export const currentOrganizationSelector = (state) =>
  state.users.currentOrganization;
export const currentActiveProjectsAmountSelector = (state) =>
  state.projects.currentActiveProjectsAmount;
export const currentOrganizationOwnerSelector = (state) =>
  state.users.currentOrganizationOwner;
export const organizationUsersSelector = (state) => state.users.items;
export const currentProjectsStructureSelector = (state) =>
  state.projects.currentProjectsStructure;
export const sharedProjectsStructureSelector = (state) =>
  state.projects.sharedProjectsStructure;

export const organizationsListSelector = (state) =>
  state.users.organizationsList;

export const archivedSubprojectsSelector = (state) =>
  state.projects.archivedSubprojects;

export const appSelector = (state) => state.app;
export const isMainLoadedSelector = (state) => state.app.isMainLoaded;
export const devInfoSelector = (state) => state.app.devInfo;
export const sharedProjectsSelector = (state) =>
  state.projects.sharedProjectsArray;
export const redirectingFromSharingSelector = (state) =>
  state.app.isRedirectFromSharing;

export const notificationsSelector = (state) => state.app.notificationsArray;
export const currentUploadingVideosSelector = (state) =>
  state.app.currentUploadingVideosInfo;

export const tariffesArraySelector = (state) => state.tariffes.tariffesArray;

export const orgTariffesSelector = (state) =>
  state.tariffes.currentOrganizationsTariffesInfo;

export const redirectUrlSelector = (state) => state.app.redirectUrl;
